module.exports = {
          srcSet: __webpack_public_path__ + "c8da4b2d6ee647727f122b545c81e1c0-881.png"+" 881w",
          images:[ {path: __webpack_public_path__ + "c8da4b2d6ee647727f122b545c81e1c0-881.png",width: 881,height: 243}],
          src: __webpack_public_path__ + "c8da4b2d6ee647727f122b545c81e1c0-881.png",
          toString:function(){return __webpack_public_path__ + "c8da4b2d6ee647727f122b545c81e1c0-881.png"},
          
          width: 881,
          height: 243
        }